import request from '@/utils/server'


export function getDeviceAlarm(query) {
    return request({
      url: '/device/getDeviceAlarm',
      method: 'get',
      params: query
    })
  }
  export function delDeviceAlarm(data) {
    return request({
      url: '/device/delDeviceAlarm',
          method: 'POST',
      data: data
    })
  }